module.exports = __webpack_public_path__ + "img/default-o.fe9e4177.png";